import React from "react";
import { ErrorBoundary } from "./ErrorBoundary";
import { FallbackUI } from "./FallbackUI";

interface GlobalErrorBoundaryProps {
  children: React.ReactNode;
}

export const GlobalErrorBoundary: React.FC<GlobalErrorBoundaryProps> = ({
  children,
}) => {
  return (
    <ErrorBoundary
      fallback={({ error, resetErrorBoundary }) => (
        <FallbackUI
          error={error}
          resetErrorBoundary={resetErrorBoundary}
          isGlobal={true}
        />
      )}
    >
      {children}
    </ErrorBoundary>
  );
};
